export enum AppType {
  Android = "android",
  IOS = "ios",
}
